var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"newspost"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"subject"},[_vm._v(" "+_vm._s(_vm.subject))]),_c('div',{staticClass:"contents"},[_vm._v(_vm._s(_vm.contents))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-label"},[_c('span',{staticClass:"title"},[_vm._v("お知らせ")])])
}]

export { render, staticRenderFns }